module.exports = __webpack_public_path__ + "0022de7643a530d049a51d5f5732ff62.png";